import React, { useRef, useState } from "react";
import style from "css/telehealth.module.css";
import { Link } from "react-router-dom";
import Questions from "components/app/questions";
import { openPopup } from "redux/slices/drawerPopupSlice";
import { useDispatch } from "react-redux";
import NeatPopup from "components/device/neat/neatPopup";
import { useMediaQuery } from "react-responsive";
import SEOMeta from "components/app/SEOMeta";
import { Swiper, SwiperSlide } from "swiper/react";
import { Scrollbar } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/scrollbar";

function Telehealth() {
  const isMobile = useMediaQuery({ query: "(max-width: 767px)" });
  const isTablet = useMediaQuery({
    query: "(min-width: 768px) and (max-width: 1024px)",
  });
  //dispatch
  const dispatch = useDispatch();
  const cardList = [
    {
      id: 1,
      img: "img/smartspace/teleinfo2Img1.png",
      title1: "Powerful API Integration Support",
      title2: "강력한 API 연동 지원",
      txt:
        !isMobile && !isTablet ? (
          <div>
            {" "}
            리브테크놀로지의 Be Gate(Gateway)는 손쉬운 API 연동을 통해 병원
            <br />
            정보시스템과 Zoom 및 WebEx와의 원활한 통합을 지원합니다. 이는
            <br />
            기존 시스템과의 호환성을 높이고, 추가 개발 비용을 절감합니다.
          </div>
        ) : (
          <div>
            리브테크놀로지의 Be Gate(Gateway)는 손쉬운 API 연동을 통해 병원
            정보시스템과 Zoom 및 WebEx와의 원활한 통합을 지원합니다. 이는 기존
            시스템과의 호환성을 높이고, 추가 개발 비용을 절감합니다.
          </div>
        ),
      component: [
        {
          txt: "Be Gate (Gateway)",
          type: true,
          link: `${process.env.REACT_APP_CLIENT_URL}smart-solution/begate`,
        },
        { txt: "API 연동", type: false, link: "" },
        { txt: "Zoom / Webex", type: true, link: "" },
      ],
    },
    {
      id: 2,
      img: "img/smartspace/teleinfo2Img2.png",
      title1: "Comprehensive Multi-Function Platform",
      title2: "다양한 기능의 통합 플랫폼",
      txt:
        !isMobile && !isTablet ? (
          <div>
            리브테크놀로지의 솔루션은 원격 진료, 협진, 의료 세미나 등 다양한
            기능을
            <br />
            하나의 플랫폼에 통합하여 제공합니다. 이는 의료진과 환자가 하나의
            <br />
            시스템에서 모든 진료 활동을 관리할 수 있게 하여 사용 편의성을
            극대화합니다.
          </div>
        ) : (
          <div>
            리브테크놀로지의 솔루션은 원격 진료, 협진, 의료 세미나 등 다양한
            기능을 하나의 플랫폼에 통합하여 제공합니다. 이는 의료진과 환자가
            하나의 시스템에서 모든 진료 활동을 관리할 수 있게 하여 사용 편의성을
            극대화합니다.
          </div>
        ),
      component: [
        {
          txt: "원격 진료 | 원격 협진 | 의료 세미나",
          type: true,
          link: "",
        },
        { txt: "통합 플랫폼", type: false, link: "" },
      ],
    },
  ];
  const cardList2 = [
    {
      id: 1,
      img: "img/smartspace/teleinfo2Img3.png",
      title1: "Superior Video Conferencing Quality",
      title2: "우수한 화상회의 품질",
      txt:
        !isMobile && !isTablet ? (
          <div>
            고성능 화상회의 장비 Neat 제품을 활용한 고해상도 화상회의 시스템은
            <br />
            끊김 없는 영상과 명확한 음성을 제공하여 원격 진료와 협진의 품질을
            <br />
            높입니다. 이는 의료진과 환자 간의 소통을 원활하게 하고, 진료의{" "}
            <br />
            정확성을 향상시킵니다.
          </div>
        ) : (
          <div>
            고성능 화상회의 장비 Neat 제품을 활용한 고해상도 화상회의 시스템은
            끊김 없는 영상과 명확한 음성을 제공하여 원격 진료와 협진의 품질을
            높입니다. 이는 의료진과 환자 간의 소통을 원활하게 하고, 진료의
            정확성을 향상시킵니다.
          </div>
        ),
      component: [
        { txt: "Neat 스마트 화상회의 장비", type: true, link: "" },
        { txt: "고성능 화상회의", type: true, link: "" },
      ],
    },
    {
      id: 2,
      img: "img/smartspace/teleinfo2Img4.png",
      title1: "Secure Data Management and Protection",
      title2: "안전한 데이터 관리 및 보안",
      txt:
        !isMobile && !isTablet ? (
          <div>
            리브테크놀로지의 시스템은 강력한 보안 기능을 통해 환자 정보와 진료
            데이터를
            <br />
            안전하게 관리합니다. 모든 통신과 데이터는 암호화되어 처리되므로,
            개인정보
            <br />
            보호를 철저히 보장합니다.
          </div>
        ) : (
          <div>
            리브테크놀로지의 시스템은 강력한 보안 기능을 통해 환자 정보와 진료
            데이터를 안전하게 관리합니다. 모든 통신과 데이터는 암호화되어
            처리되므로, 개인정보 보호를 철저히 보장합니다.
          </div>
        ),
      component: [
        {
          txt: "데이터 암호화",
          type: true,
          link: "",
        },
        { txt: "개인정보 보호", type: false, link: "" },
        { txt: "강력한 보안 기능", type: false, link: "" },
      ],
    },
  ];

  const scrollContainerRef = useRef(null);

  const handleMouseDown = (e) => {
    const container = scrollContainerRef.current;
    container.isDown = true;
    container.startX = e.pageX - container.offsetLeft;
    container.scrollLeft = container.scrollLeft;
  };

  const handleMouseLeave = () => {
    const container = scrollContainerRef.current;
    container.isDown = false;
  };

  const handleMouseUp = () => {
    const container = scrollContainerRef.current;
    container.isDown = false;
  };

  const handleMouseMove = (e) => {
    const container = scrollContainerRef.current;
    if (!container.isDown) return;
    e.preventDefault();
    const x = e.pageX - container.offsetLeft;
    const walk = (x - container.startX) * 0.5; // 스크롤 속도 조절
    container.scrollLeft = container.scrollLeft - walk;
  };

  const ComposeHeader = (
    <div className={style.commonComposeTitle}>
      원격진료 시스템 <font>구성 환경</font>
    </div>
  );

  const Compose = [
    {
      id: 1,
      img: `img/device/neat/swiper_medilink${!isMobile && !isTablet ? "" : "_m"}.png`,
      title: "원격진료 & 화상회진 솔루션, MediLink",
      txt: "MediLink는 Zoom API와 병원 종합의료정보 시스템(HIS)을 연동하여 원격진료와 화상회진을 지원하는 통합 솔루션입니다. 환자와 의료진, 보호자를 연결해 효율적인 의료 환경을 제공하며, 병원 환경에 맞춘 커스터마이징이 가능합니다.",
      onClick: () => showDrawer("medilink"),
    },
    {
      id: 2,
      img: `img/device/neat/swiper_frame${!isMobile && !isTablet ? "" : "_m"}.png`,
      title: "neat. frame",
      txt: "Neat Frame은 개인 협진 및 원격 진료에 최적화된 올인원 화상회의 디바이스로, 병원 진료실, 개별연구실, 원격 근무 환경에서 의료진 간 원활한 협업을 지원합니다. 공간을 최소화하면서도 최적의 협진 환경을 제공하는 스마트 디바이스 입니다.",
      onClick: () => showDrawer("frame"),
    },
    // {
    //   id: 2,
    //   img: `img/device/neat/swiper_board_32${!isMobile && !isTablet ? "" : "_m"}.png`,
    //   title: "neat. board 32",
    //   txt: "Neat Board 32는 화면, 마이크, 스피커가 하나로 구성된 회의 전용 디바이스 입니다. 직관적인 터치 화면과 자동 카메라 조정 기능으로 소규모 회의나 협업 공간에서 집중도 높은 영상회의 환경을 제공합니다.",
    //   onClick: () => showDrawer("board32"),
    // },
  ];
  const showDrawer = (menu) => {
    dispatch(
      openPopup({
        type: menu,
      }),
    );
    document.querySelector("#page_header").style.height = "0";
  };

  const [exNum, setExNum] = useState(1);
  const exList = [
    {
      id: 1,
      title: "접근성 향상",
      txt: "원격진료는 환자들이 시간과 장소에 구애 받지 않고 진료를 받을 수 있는 기회를 제공합니다. 특히 교통이 불편한 지역에 거주하거나 거동이 불편한 환자에게 매우 유용합니다. 이러한 접근성 향상은 의료 서비스의 형평성을 높이며, 모든 환자가 필요한 진료를 적시에 받을 수 있도록 도와줍니다.",
    },
    {
      id: 2,
      title: "편리성 증대",
      txt: "원격진료는 병원 방문 없이 집에서 간편하게 진료를 받을 수 있어 환자의 대기 시간과 이동 시간을 크게 절약할 수 있습니다. 이는 특히 바쁜 직장인이나 학업 중인 학생들에게 유리합니다. 또한, 원격진료 시스템을 통해 환자는 예약, 진료, 처방까지 한번에 진행할 수 있어 전반적인 의료 이용 경험이 개선됩니다.",
    },
    {
      id: 3,
      title: "감염 위험 감소",
      txt: "병원 방문 시 발생할 수 있는 감염 위험을 최소화할 수 있습니다. 이는 특히 전염병이 유행하는 시기나 면역력이 약한 환자들에게 중요합니다. 병원 내 감염을 예방함으로써 환자와 의료진 모두의 안전을 보호할 수 있으며, 병원 자원의 효율적인 사용에도 기여합니다.",
    },
    {
      id: 4,
      title: "의료 자원 효율적 활용",
      txt: "원격진료를 통해 의료진이 보다 효율적으로 시간을 관리할 수 있어 더 많은 환자를 진료할 수 있습니다. 이를 통해 병원의 진료 능력이 향상되고, 응급 상황이나 중증 환자에게 더 많은 자원을 할애할 수 있습니다. 또한, 원격진료 시스템은 진료 기록과 데이터를 자동으로 저장하고 관리하여 의료진의 업무 부담을 줄이고, 의료 서비스의 질을 높일 수 있습니다.",
    },
    {
      id: 5,
      title: "진료의 지속성 및 연속성 보장",
      txt: "환자들은 정기적인 진료와 상담을 받을 수 있어 만성 질환 관리에 효과적입니다. 주기적인 원격 상담은 환자의 상태를 지속적으로 모니터링하고, 필요시 즉각적인 대응을 가능하게 하여 질환 악화를 예방할 수 있습니다. 또한, 환자와 의료진 간의 지속적인 소통이 가능하여 치료 계획의 연속성을 보장합니다.",
    },
  ];

  return (
    <>
      <SEOMeta
        title="원격 진료 시스템, 리브테크놀로지"
        description="리브테크놀로지 riv Technolohy - 원격 진료 시스템"
        keywords="리브테크놀로지, 리브테크, 리브, riv, riv Technology, neat, 텔레헬스, 비대면 진료, 
        스마트 텔레헬스 시스템, 원격 진료"
      />
      <NeatPopup />
      <div className={style.wrapper}>
        <div className={style.healthTitle}>
          <p>Telehealth System</p>
          <p>원격 진료 시스템</p>
          {!isMobile && !isTablet ? (
            <p>
              스마트 텔레헬스 시스템은 주요 데스크톱 및 모바일 브라우저에서
              간단히 작동하며, <br />
              다운로드나 설치가 필요하지 않아 접근성이 뛰어납니다.
              <br /> 환자와 의료진 모두가 쉽게 사용할 수 있도록 설계되어
              텔레헬스를 더욱 편리하게 이용할 수 있습니다.
            </p>
          ) : (
            <p>
              스마트 텔레헬스 시스템은 주요 데스크톱 및<br /> 모바일
              브라우저에서 간단히 작동하며, <br />
              다운로드나 설치가 필요하지 않아 접근성이 뛰어납니다.
              <br />
              환자와 의료진 모두가 쉽게 사용할 수 있도록 설계되어
              <br />
              텔레헬스를 더욱 편리하게 이용할 수 있습니다.
            </p>
          )}
        </div>
        <div className={style.healthImg}>
          <img
            alt=""
            src={`${process.env.REACT_APP_CLIENT_URL}img/smartspace/teleImg1${!isMobile && !isTablet ? "" : "_m"}.png`}
          />
        </div>

        <div className={style.healthBody1}>
          <div className={style.healthContents}>
            <p className={style.healthContentsHeader}>
              의료의 새로운 기준,
              <br />
              <font>모든 사람을 위한 원격진료</font>
            </p>
            <div className={style.mainExBody}>
              <div className={style.meritBodyImg}>
                <div className={`${style.meritBodyImgSlide}`}>
                  <img
                    alt=""
                    className={style.sli1}
                    src={`${process.env.REACT_APP_CLIENT_URL}img/smartspace/telemerit0${!isMobile && !isTablet ? "" : "_m"}.png`}
                  />
                  {/* <img
                    alt=""
                    className={exNum === 1 ? style.sli1 : style.slioff1}
                    src={
                      `${process.env.REACT_APP_CLIENT_URL}` +
                      "img/smartspace/telemerit1.png"
                    }
                  />
                  <img
                    alt=""
                    className={exNum === 2 ? style.sli2 : style.slioff2}
                    src={
                      `${process.env.REACT_APP_CLIENT_URL}` +
                      "img/smartspace/telemerit1.png"
                    }
                  />
                  <img
                    alt=""
                    className={exNum === 3 ? style.sli3 : style.slioff3}
                    src={
                      `${process.env.REACT_APP_CLIENT_URL}` +
                      "img/smartspace/telemerit1.png"
                    }
                  />
                  <img
                    alt=""
                    className={exNum === 4 ? style.sli4 : style.slioff4}
                    src={
                      `${process.env.REACT_APP_CLIENT_URL}` +
                      "img/smartspace/telemerit1.png"
                    }
                  />
                  <img
                    alt=""
                    className={exNum === 5 ? style.sli5 : style.slioff5}
                    src={
                      `${process.env.REACT_APP_CLIENT_URL}` +
                      "img/smartspace/telemerit1.png"
                    }
                  /> */}
                </div>
              </div>

              <div className={style.meritClickList}>
                {exList.map((info) =>
                  info.id === exNum ? (
                    <div className={style.meritClickBtn_on + " cursor"}>
                      <div>
                        <p>
                          <font>0{info.id}</font>
                          <font>{info.title}</font>
                        </p>
                        <p>
                          <img
                            alt=""
                            src={`${process.env.REACT_APP_CLIENT_URL}img/smartspace/telemainMinus${!isMobile && !isTablet ? "" : "_m"}.png`}
                          />
                        </p>
                      </div>
                      <div>{info.txt}</div>
                    </div>
                  ) : (
                    <div
                      className={style.meritClickBtn_off + " cursor"}
                      onClick={() => setExNum(info.id)}
                    >
                      <div>
                        <p>
                          <font>0{info.id}</font>
                          <font> {info.title}</font>
                        </p>
                        <p>
                          {" "}
                          <img
                            alt=""
                            src={`${process.env.REACT_APP_CLIENT_URL}img/smartspace/telemainPlus3${!isMobile && !isTablet ? "" : "_m"}.png`}
                          />
                        </p>
                      </div>
                      <div>{info.txt}</div>
                    </div>
                  ),
                )}
              </div>
            </div>
          </div>
        </div>
        <div
          className={style.healthBody2}
          style={{
            backgroundImage: `url('${process.env.REACT_APP_CLIENT_URL}img/smartspace/teleBackgroundImg${!isMobile && !isTablet ? "" : "_m"}.png')`,
          }}
        >
          <div className={style.healthContents2}>
            {!isMobile && isTablet ? (
              <section>
                <p>리브테크놀로지의 Telehealth </p>
                <p>원격진료 시스템</p>
              </section>
            ) : (
              <section>
                리브테크놀로지의 Telehealth
                <br />
                <bold>원격진료 시스템</bold>
              </section>
            )}
            <section>
              {cardList.map((info) => (
                <div className={style.teleinfo2Card}>
                  <div>
                    <p>
                      <img
                        alt=""
                        src={`${process.env.REACT_APP_CLIENT_URL}` + info.img}
                      />
                    </p>
                    <p>
                      <font>{info.title1}</font>
                      <font>{info.title2}</font>
                    </p>
                  </div>
                  {info.txt}
                  <div>
                    {info.component.map((data) => (
                      <p>
                        <font />
                        {data.txt}
                        {data.link !== "" && (
                          <Link to={data.link}>
                            <img
                              className={style.gotoLink}
                              alt=""
                              src={`${process.env.REACT_APP_CLIENT_URL}img/smartspace/gotoLink${!isMobile && !isTablet ? "" : "_m"}.png`}
                            />
                          </Link>
                        )}
                      </p>
                    ))}
                  </div>
                </div>
              ))}
            </section>
            <section>
              {cardList2.map((info) => (
                <div className={style.teleinfo2Card}>
                  <div>
                    <p>
                      <img
                        alt=""
                        src={`${process.env.REACT_APP_CLIENT_URL}` + info.img}
                      />
                    </p>
                    <p>
                      <font>{info.title1}</font>
                      <font>{info.title2}</font>
                    </p>
                  </div>
                  {info.txt}
                  <div>
                    {info.component.map((data) => (
                      <p>
                        <font />
                        {data.txt}
                        {data.link !== "" && (
                          <img
                            className={style.gotoLink}
                            alt=""
                            src={`${process.env.REACT_APP_CLIENT_URL}img/smartspace/gotoLink${!isMobile && !isTablet ? "" : "_m"}.png`}
                          />
                        )}
                      </p>
                    ))}
                  </div>
                </div>
              ))}
            </section>
          </div>
        </div>

        <div className={style.commonCompose}>
          <div className={style.commonCompseBody}>
            {ComposeHeader}

            <Swiper
              scrollbar={{ draggable: true }}
              slidesPerView={"auto"}
              spaceBetween={"4%"}
              modules={[Scrollbar]}
              className={style.commonComposeCardWrap}
              observer={true}
              observeParents={true}
              observeSlideChildren={true}
              grabCursor={true}
            >
              {Compose.map((info, index) => (
                <SwiperSlide className={style.commonComposeCard} key={index}>
                  <div className={style.commonComposeCardImg}>
                    <p>
                      <font>{info.id}</font> / {Compose.length}
                    </p>
                    <img
                      alt=""
                      src={`${process.env.REACT_APP_CLIENT_URL}` + info.img}
                    />
                  </div>
                  <div className={style.commonComposeCardTxt}>
                    <p>{info.title}</p>
                    <p>{info.txt}</p>
                  </div>
                  <div className={style.commonComposeCardMore}>
                    <div onClick={info.onClick}>
                      <font>More</font>{" "}
                      <img
                        alt=""
                        src={
                          `${process.env.REACT_APP_CLIENT_URL}` +
                          "img/smartspace/arrowRight.png"
                        }
                      />
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>

            {/* <div
              className={style.commonComposeCardWrap}
              ref={scrollContainerRef}
              onMouseDown={handleMouseDown}
              onMouseLeave={handleMouseLeave}
              onMouseUp={handleMouseUp}
              onMouseMove={handleMouseMove}
            >
              {Compose.map((info) => (
                <div className={style.commonComposeCard}>
                  <div className={style.commonComposeCardImg}>
                    <p>
                      <font>{info.id}</font> / {Compose.length}
                    </p>
                    <img
                      alt=""
                      src={`${process.env.REACT_APP_CLIENT_URL}` + info.img}
                    />
                  </div>
                  <div className={style.commonComposeCardTxt}>
                    <p>{info.title}</p>
                    <p>{info.txt}</p>
                  </div>
                  <div className={style.commonComposeCardMore}>
                    <div onClick={info.onClick}>
                      <font>More</font>{" "}
                      <img
                        alt=""
                        src={
                          `${process.env.REACT_APP_CLIENT_URL}` +
                          "img/smartspace/arrowRight.png"
                        }
                      />
                    </div>

                  </div>
                </div>
              ))}
            </div> */}
            <div className={style.commonComposeFooter}>
              <div
                style={{
                  backgroundImage: `url('${process.env.REACT_APP_CLIENT_URL}img/smartspace/composefooterImg${!isMobile && !isTablet ? "" : "_m"}.png')`,
                }}
              >
                <p>
                  <img
                    className={style.bang}
                    alt=""
                    src={`${process.env.REACT_APP_CLIENT_URL}img/smartspace/bang${!isMobile && !isTablet ? "" : "_m"}.png`}
                  />
                </p>
                {!isMobile && !isTablet ? (
                  <p>
                    <font>기업 환경에 맞춰</font> 선택하여 구축 가능합니다.
                    상담을 통해 정확히 진단해 보세요.
                  </p>
                ) : (
                  <p>
                    <bold>기업 환경에 맞춰</bold> 선택하여 구축 가능합니다.
                    <br />
                    상담을 통해 정확히 진단해 보세요.
                  </p>
                )}
              </div>
            </div>
          </div>
        </div>
        <Questions />
      </div>
    </>
  );
}

export default Telehealth;
